import { cookie } from '@pmi/pmi-iqos-shared-react'

export default class IqosphereAuth {
  constructor(api) {
    this.api = api
  }

  getPosition = async (sync = false, fetchNotices = false, logout = false) => {
    const res = await this.api.get(
      '/iqosphere/position' +
        (sync ? '?sync=true' : '') +
        (logout ? '?logout=true' : ''),
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        data: {
          notices: fetchNotices
        },
        useProxy: true,
        withCredentials: true,
        mock: this.api.getMock('position')
      }
    )
    return res
  }

  lineConnection = async () => {
    const res = await this.api.post('/line/corezoid', {
      data: {
        timeout: 60,
        ops: [
          {
            conv_id: '6321',
            type: 'create',
            obj: 'task',
            data: {
              spice_id: 'id12345678',
              line_id: 'id987654',
              status: 'success',
              sub_status: 'ok',
              type: 'auth',
              token: 'atn_token123',
              created_at: '17253085951234',
              meta_info: {
                page: 'login',
                referrer_url: 'https://line.me/en/login'
              }
            }
          }
        ]
      }
    })
    return res
  }
}
